import { Spacer, Typography } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

// Carve-out: DS5 Stepper requires a labeled StepperStep[] and always renders step circles; this
// usage is an unlabeled gray bar driven by a bare step count, so migrating needs a design decision.
import { Stepper } from "@aviary";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";
import { l } from "@shared/locales/i18n";

import * as styles from "./PractitionerOnboardingStepper.styles";

interface Props {
  currentStep: number;
}

const PractitionerOnboardingStepper = ({ currentStep }: Props) => {
  const { phoneLarge } = useBreakpoints();
  const { t } = useTranslation();
  const { isCanada } = useSharedGlobalConfig();

  const NUMBER_OF_STEPS = isCanada ? 4 : 5;
  const text = `${t(l.sharedCommon.Step)} ${currentStep}/${NUMBER_OF_STEPS}`;

  return (
    <div css={styles.wrapper}>
      <Typography variant="h5" isMarginless intention="neutral" colorIntensity="bold">
        <span css={styles.stepText}>{text}</span>
      </Typography>
      <Spacer size="xsmall" />
      {!!phoneLarge.greaterThan && (
        <Stepper
          size="small"
          steps={NUMBER_OF_STEPS}
          currentStep={currentStep}
          showStatusLabel
          hideAtoms
          isRounded
          isGray
        />
      )}
      <Spacer size={phoneLarge.greaterThan ? "large" : "medium"} />
    </div>
  );
};

export { PractitionerOnboardingStepper };
